import styles from "./styles.module.scss";

const Loading = (): JSX.Element => (
  <div className={styles.Loading}>
    <p>Loading...</p>
  </div>
);

export default Loading;
